import EventBus from "common/eventbus";
import Events from "common/events";
import { initApp } from "components/jiffy/jiffy-services-preview/jiffy-services-preview";
import initMadeSampleCTA from "components/jiffy/product-details-made-sample-cta/product-details-made-sample-cta";
import { getFormPayload } from "components/jiffy/vue-product-details-dtf/utils";
import { api } from "jiffy-api";

import "./product-details-header.scss";

const $getSoftnessScoreAll = () => document.querySelectorAll(".js-header-softness-score");
const $getSoftnessScore = $badge => $badge.querySelector(".js-softness-score-number");
const $getSoftnessRating = $badge => $badge.querySelector(".js-softness-score-rating");
const $getCreditBalance = () => document.querySelectorAll(".js-credit-balance");
const $getSampleAddToCartLink = () => document.querySelector(".js-dtf-sample-add-to-cart");
const $getDesignLabCTAButton = () => document.querySelector(".js-design-lab-cta-button");
const $getProductDetailsQuantityForm = () =>
  document.querySelector(".js-product-details-quantity-form");

const updateSoftnessScore = (_, { softness }) => {
  const isHiddenBadges = !Object.keys(softness).length;

  $getSoftnessScoreAll().forEach($badge => {
    $badge.classList.toggle("hidden", isHiddenBadges);

    if (!isHiddenBadges) {
      $getSoftnessScore($badge).textContent = softness.score;
      $getSoftnessRating($badge).style.width = `${softness.percentage}%`;
    }
  });
};

const updateCreditsAvailable = ({ target }) => {
  const totalAmount = target?.userStoreCredits?.transfers?.totalAmount;
  const formattedTotalAmount = Number(totalAmount || 0).toFixed(2);

  const $creditBalances = $getCreditBalance();
  if (!$creditBalances || $creditBalances.length === 0) return;

  $creditBalances.forEach($balance => {
    if (!$balance) return;

    const $amount = $balance.querySelector(".js-credit-balance-amount");
    if ($amount) {
      $amount.textContent = `$${formattedTotalAmount}`;
    }
  });
};

const addSampleToCart = () => {
  const { variantId } = $getSampleAddToCartLink().dataset;
  if (!variantId) return;

  const payload = {
    ...getFormPayload(),
    sample_pack: true,
    artworks: [
      {
        artwork_id: 0,
        width: 1,
        height: 1,
        quantity: 1,
        variant_id: variantId,
        sample_pack: true
      }
    ]
  };

  api.dtf.addToCart(payload).then(_res => {
    window.location = "/cart";
  });
};

const designLabActionHandler = () => {
  const ctaButton = $getDesignLabCTAButton();
  const isStartDesign = ctaButton.dataset.isStartDesign === "true";

  if (isStartDesign) {
    $getProductDetailsQuantityForm().submit();
  } else {
    const activeColorDomNode = document.querySelector(".js-color-variant-selector-active");
    const activeColor = activeColorDomNode?.dataset.color;
    const activeCompositionId = activeColorDomNode?.dataset.compositionId;
    const catalogId = ctaButton.dataset.catalogNumber;

    window.parent.postMessage(
      {
        type: "designlabmodal:productadded",
        payload: {
          catalogId,
          colorName: activeColor,
          compositionId: activeCompositionId
        }
      },
      "*"
    );
  }
};

export default () => {
  initApp(".js-upsell-container");
  initMadeSampleCTA();

  EventBus.on(Events.PRODUCT_COLOR_SELECTED, updateSoftnessScore);
  EventBus.on(Events.PRICING_UPDATED, updateCreditsAvailable);

  $getSampleAddToCartLink()?.addEventListener("click", addSampleToCart);
  $getDesignLabCTAButton()?.addEventListener("click", designLabActionHandler);
};
